import styled from 'styled-components/macro';

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0 10px 0;
`;

export const ControlsSearch = styled.div`
  width: 257px;
`;

export const ControlsButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > * {
    margin-left: 8px;
  }
`;

export const TableWrapper = styled.div`
  padding-bottom: 100px;
  table {
    position: relative;
    thead {
      position: sticky;
      top: -18px;
      z-index: 9;
      tr {
        th {
          padding: 5px 10px 10px 10px;
        }
      }
    }
  }
`;
